// The header and the conversation page are separate React roots. The header
// gets its unread count from the server at page load; the conversation page
// announces the count again whenever it marks a conversation read.
export const UNREAD_COUNT_EVENT = 'conversations:unread-count'

export const broadcastUnreadCount = (conversations) => {
  const count = conversations.filter((c) => c.unread).length
  window.dispatchEvent(new CustomEvent(UNREAD_COUNT_EVENT, { detail: { count } }))
}
